/*
 * Copyright (c) 2026 Joseph Duggan. All rights reserved.
 */
/**
 * Microcopy for second (codebase: sidekick).
 *
 * Strings are sourced from the brand brief at
 * apps/web/design-reference/uploads/. Keyed for i18n (per
 * docs/DESIGN-PRINCIPLES.md §4) even though only `en-US` ships in v1.
 *
 * Banned vocabulary (do not introduce): "productivity", "tasks", "AI
 * assistant", "powered by", "supercharge", "your second self".
 * The voice is 21st-century barrister — restrained, literate,
 * present-tense.
 */
export const copy = {
    enUS: {
        brand: {
            wordmark: 'second',
            tagline: 'Someone keeping your day.',
            taglines: [
                'Every protagonist has a Second.',
                "Stand with someone who's been through it.",
                'Before the duel, the Second.',
                'Your Second, before the day begins.',
                'Someone keeping your day.',
            ],
            retainer: 'A retainer · est. mmxxvi',
        },
        nav: {
            letter: 'The Letter',
            docket: 'The Docket',
            constitution: 'The Constitution',
            weeklyReview: 'Weekly Review',
            quarterlyReview: 'Quarterly Review',
            record: 'The Record',
            counsel: 'Counsel',
            account: 'The Account',
        },
        letter: {
            sectionLabel: 'A letter is on your desk',
            greeting: 'Good morning —',
            signoff: '— Your Second',
            readingTime: (minutes) => `Read · ${minutes} min`,
            replyAction: 'Reply with a note',
            openCounsel: 'Open Counsel',
            empty: 'The desk is clear. Write when you’re ready.',
            generate: 'Engage your Second',
            generating: 'Your Second is reading the week…',
            energyHeader: 'Before the letter, a moment.',
            energyHint: 'Three numbers, on a five-point scale. Physical, mental, emotional. This shapes today’s posture.',
            energyLabels: {
                physical: 'Physical',
                mental: 'Mental',
                emotional: 'Emotional',
            },
        },
        auth: {
            signInTitle: 'Engage your Second',
            signInHint: 'Two voices in the morning — yours, and mine.',
            signOut: 'Take leave',
        },
        moments: {
            hello: "I'll be your Second.",
            morningReady: 'A letter is on your desk.',
            coachingEntry: 'Sit with it for a moment?',
            shutdownDone: 'The day is closed. Until morning.',
            noted: 'Marked in the margin.',
        },
    },
};
/** Convenience: default locale strings. */
export const t = copy.enUS;
//# sourceMappingURL=index.js.map